const GLOBAL_DEFAULTS = {
    test: false,
};
const CONFIG = {
    localhost: Object.assign(Object.assign({}, GLOBAL_DEFAULTS), { restAPIUrl: 'https://apigateway.integration.misp-solutions.com/changelogs/changelog', test: true }),
    dev: Object.assign(Object.assign({}, GLOBAL_DEFAULTS), { restAPIUrl: '' }),
    test: Object.assign(Object.assign({}, GLOBAL_DEFAULTS), { googleMapsApiKey: 'AIzaSyBDoZRdW4nlR88lNTU6I5OOFAWNZASEqyk', restAPIUrl: '' }),
    staging: Object.assign(Object.assign({}, GLOBAL_DEFAULTS), { restAPIUrl: '' }),
    prod: Object.assign(Object.assign({}, GLOBAL_DEFAULTS), { restAPIUrl: '' }),
};
// eslint-disable-next-line import/no-mutable-exports
let config;
if (window.location.hostname.includes('localhost') || window.location.hostname.includes('.chaos')) {
    config = CONFIG.localhost;
}
else if (window.location.hostname.includes('-dev.')) {
    config = CONFIG.dev;
}
else if (window.location.hostname.includes('-test.')) {
    config = CONFIG.test;
}
else if (window.location.hostname.includes('-staging.')) {
    config = CONFIG.staging;
}
else {
    config = CONFIG.prod;
}
export default config;
//# sourceMappingURL=global-variables.js.map